import { Spin } from 'antd'
import { useUpdateEffect } from 'ahooks'
import { Trans } from '@lingui/react/macro'

import type { MusicListDataItem } from '@/pages/tad.ai/ai-music-generator/_types/trpc'

import MusicItem from '@/pages/tad.ai/_components/MusicItem'
import { transformMusicData } from '@/pages/tad.ai/_components/MusicList/_helpers/data'
import { useInWhichPage } from '@/hooks/useInWhichPage'
import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'
import { useMusicOptionsStore } from '@/pages/tad.ai/_components/MusicItem/_components/MusicOptions/store'
import { DiscoverTrackProvider } from '@/pages/tad.ai/_hooks/discoverTrack'

export interface IProps {
  templateId?: number
  title?: string
  musics?: MusicListDataItem[]
  showMore?: boolean
}
export function ListBlock(props: IProps) {
  const { musics: outerMusics, templateId, title, showMore } = props
  const { setLikeStatus } = useMusicOptionsStore()
  const shouldFetch = templateId !== undefined
  const {
    data: { musics: innerMusics } = { musics: [] },
    refetch,
    isFetching,
  } = api.music_v2.getMusicList.useQuery(
    {
      pageNumber: 1,
      pageSize: 12,
      templateId,
    },
    {
      enabled: shouldFetch,
      staleTime: 120 * 1000,
      cacheTime: 600 * 1000,
      keepPreviousData: true,
      onSuccess: (data) => {
        data.musics.forEach((item) => {
          setLikeStatus(item.uuid, {
            isLiked: !!item.isLiked,
            favoriteNum: item.favoriteNum || 0,
          })
        })
      },
    },
  )
  const { isSignIn } = useSessionInfo()
  const musics = outerMusics?.length ? outerMusics : innerMusics
  const transformedData = useMemo(() => {
    return musics.map((item) => {
      return transformMusicData(item, true)
    })
  }, [musics])

  const { inHomepageDetail } = useInWhichPage()
  useUpdateEffect(() => {
    if (shouldFetch) {
      refetch()
    }
  }, [isSignIn])

  if (musics.length === 0) return null

  return (
    <DiscoverTrackProvider value={title}>
      <div className={cls`flex flex-col gap-3`}>
        <div className={cls`flex items-center justify-between text-[18px]`}>
          {title}
          {showMore && (
            <Link
              className={cls`text-f-text-tertiary flex cursor-pointer items-center gap-2 text-[16px]`}
              href={`/homepage/detail/template/${templateId}?name=${title}`}
            >
              <Trans>More</Trans>
              <span className={cls`i-cus--tad-right`} />
            </Link>
          )}
        </div>
        <Spin spinning={isFetching}>
          <div
            className={cls`
              grid grid-cols-1 gap-x-3 lg:grid-cols-2 xl:grid-cols-3 [&>div]:min-w-[327px]
              ${
              !inHomepageDetail
                ? cls`
                  [&>div:nth-child(-n+4)]:flex [&>div:nth-child(n+5)]:hidden [&>div:nth-child(n+5)]:lg:flex
                                    [&>div:nth-child(n+9)]:lg:hidden [&>div:nth-child(n+9)]:xl:flex
                `
                : ''
            }
            `}
          >
            {transformedData.map((item) => (
              <MusicItem
                key={item.id}
                data={item}
                onRetry={() => Promise.resolve()}
                fromList={transformedData}
                showTypes={[
                  'labels',
                  'userInfo',
                  'duration',
                  { key: 'liked', iconOnly: false },
                ]}
                onlyExpand
              />
            ))}
          </div>
        </Spin>
      </div>
    </DiscoverTrackProvider>
  )
}
